"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = void 0;
const constants_1 = require("@framework/constants");
// @ts-ignore
const en_json_1 = __importDefault(require("../i18n/en.json"));
// @ts-ignore
const countries_json_1 = __importDefault(require("../i18n/en/countries.json"));
// @ts-ignore
const schedule_json_1 = __importDefault(require("../i18n/en/schedule.json"));
// @ts-ignore
const ru_json_1 = __importDefault(require("../i18n/ru.json"));
// @ts-ignore
const countries_json_2 = __importDefault(require("../i18n/ru/countries.json"));
// @ts-ignore
const schedule_json_2 = __importDefault(require("../i18n/ru/schedule.json"));
en_json_1.default.enums.country = countries_json_1.default;
en_json_1.default.enums.schedule = schedule_json_1.default;
ru_json_1.default.enums.country = countries_json_2.default;
ru_json_1.default.enums.schedule = schedule_json_2.default;
exports.i18n = {
    [constants_1.EnabledLanguages.EN]: en_json_1.default,
    [constants_1.EnabledLanguages.RU]: ru_json_1.default,
};
//# sourceMappingURL=index.js.map